export const awards = {
  title: "Awards",
  subtitle: "Visa HR-priser för den valda organisationen.",
  select_organisation_title: "Välj en organisation",
  select_organisation_subtitle: "Välj en organisation för att se dess priser.",
  no_awards_title: "Inga priser ännu",
  no_awards_subtitle: "Det finns inga priser för denna organisation just nu.",
  awards_count: "Awards",
  award: "Award",
  create_title: "Skapa ett nytt pris",
  label_name: "Namn",
  label_description: "Beskrivning",
  label_coin_price: "Myntpris",
  label_max_claims: "Max antal krav",
  label_is_active: "Aktiv",
  btn_create_award: "Skapa pris",
  create_success: "Priset skapades.",
  field_created: "Skapat",
  field_status: "Status",
  field_price: "Myntpris",
  field_max_claims: "Max krav",
  field_claimed_count: "Krävda",
  field_remaining_claims: "Återstående krav",
  status_active: "Aktiv",
  status_inactive: "Inaktiv",
  delete_confirm_title: "Radera pris",
  delete_confirm_message: "Är du säker på att du vill radera detta pris?",
  delete_success: "Priset raderades.",
  error_delete_award: "Det gick inte att radera priset.",
  toggle_success: "Prisstatus uppdaterad.",
  error_toggle_award: "Det gick inte att uppdatera prisstatus.",
  btn_view_winners: "Visa vinnare",
  winners_title: "Prisvinnare",
  winners_subtitle: "Se vilka som har hämtat detta pris.",
  no_winners_title: "Inga vinnare ännu",
  no_winners_subtitle: "Inga krav har gjorts för detta pris än.",
  field_email: "E-post",
  field_claimed_at: "Krävd",
  unknown_winner: "Vinnare",
  select_account_message: "Välj en organisation för att ladda priser.",
  error_loading_awards: "Det gick inte att ladda priser.",
  error_loading_award_winners: "Det gick inte att ladda prisvinnare.",
};
